(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ppsdkconstants", [], factory);
	else if(typeof exports === 'object')
		exports["ppsdkconstants"] = factory();
	else
		root["ppsdkconstants"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 